<template>
    <span class="badge rounded-pill" :class="classes"><Icon v-if="icon" :icon="icon" class="me-1" /><slot></slot></span>
</template>

<script>
    export default {
        name: 'Badge',
        props: {
            small: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: 'primary',
                validator: function (value) {
                    return ['primary', 'primary-alt', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'white', 'dark'].includes(value)
                }
            },
            icon: String
        },
        computed: {
            classes: function() {
                return [
                    { 'bg-success': this.color === 'success' },
                    { 'bg-warning': this.color === 'warning' },
                    { 'bg-danger': this.color === 'danger' },
                    { 'bg-primary': this.color === 'primary' },
                    { 'bg-primary-alt': this.color === 'primary-alt' },
                    { 'bg-secondary': this.color === 'secondary' },
                    { 'bg-light': this.color === 'light' },
                    { 'bg-white': this.color === 'white' },
                    { 'bg-dark': this.color === 'dark' },
                    { 'bg-info': this.color === 'info' },
                    this.color === 'light' || this.color === 'white' ? 'text-secondary' : 'text-white',
                    { 'badge-lg': this.large },
                    { 'badge-sm': this.small }
                ]
            }
        }
    }
</script>